import { EnvKey } from "~/providers/EnvProvider"

export const useEnv = () => {
  const env = inject(EnvKey)
  if (!env) {
    throw new Error("useEnv must be used within a EnvProvider")
  }
  return env
}
